import { Badge } from "@pushpress/pushpress-ui";
import { MemberDataType, StepIdType, StepType } from "../../../types";

export default function SelectActivatingUsers({
  activateSelection,
  setActivateSelection,
  membersData,
  error,
}: {
  activateSelection: StepType["id"];
  setActivateSelection: (value: StepType["id"]) => void;
  membersData: MemberDataType[];
  error: string | null;
}) {
  return (
    <>
      <fieldset
        aria-label="Select who to activate"
        className="tw--space-y-px tw-rounded-md tw-bg-white"
      >
        <label
          key={StepIdType.WHO_TO_PROMPT}
          htmlFor={StepIdType.WHO_TO_PROMPT}
          aria-label="All 'ready' members selection"
          className="tw-group tw-flex tw-cursor-pointer tw-border tw-border-gray-200 tw-mb-0 tw-p-4 first:tw-rounded-tl-md first:tw-rounded-tr-md last:tw-rounded-bl-md last:tw-rounded-br-md focus:tw-outline-none has-[:checked]:tw-relative has-[:checked]:tw-border-blue-200 has-[:checked]:tw-bg-blue-50"
        >
          <input
            id={StepIdType.WHO_TO_PROMPT}
            value={StepIdType.WHO_TO_PROMPT}
            name={StepIdType.WHO_TO_PROMPT}
            checked={activateSelection === StepIdType.WHO_TO_PROMPT}
            onChange={() => setActivateSelection(StepIdType.WHO_TO_PROMPT)}
            type="radio"
            className={`tw-relative ${
              error ? "tw-border-red-500" : ""
            } tw-mt-0.5 tw-size-4 tw-shrink-0 tw-appearance-none tw-rounded-full tw-border tw-border-gray-300 tw-bg-white before:tw-absolute before:tw-inset-1 before:tw-rounded-full before:tw-bg-white checked:tw-border-blue-600 checked:tw-bg-blue-600 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-blue-600 disabled:tw-border-gray-300 disabled:tw-bg-gray-100 disabled:before:tw-bg-gray-400 forced-colors:tw-appearance-auto forced-colors:before:tw-hidden [&:not(:checked)]:before:tw-hidden`}
          />
          <span className="tw-ml-3 tw-flex tw-flex-row tw-justify-between tw-w-full">
            <span className="tw-block tw-text-sm tw-font-medium tw-text-gray-900 group-has-[:checked]:tw-text-blue-900">
              All &apos;ready&apos; members ({membersData.length})
            </span>
            <Badge
              variant="secondary"
              className="tw-bg-gray-100 tw-text-gray-600 tw-hover:tw-bg-gray-100 tw-rounded-full tw-px-3"
            >
              RECOMMENDED
            </Badge>
          </span>
        </label>
        <label
          key="select-members-table"
          htmlFor="select-members-table"
          aria-label="Some members"
          className="tw-group tw-flex tw-cursor-pointer tw-border tw-border-gray-200 tw-mb-0 tw-p-4 first:tw-rounded-tl-md first:tw-rounded-tr-md last:tw-rounded-bl-md last:tw-rounded-br-md focus:tw-outline-none has-[:checked]:tw-relative has-[:checked]:tw-border-blue-200 has-[:checked]:tw-bg-blue-50"
        >
          <input
            id={StepIdType.SELECT_MEMBERS_TABLE}
            value={StepIdType.SELECT_MEMBERS_TABLE}
            name={StepIdType.SELECT_MEMBERS_TABLE}
            checked={activateSelection === StepIdType.SELECT_MEMBERS_TABLE}
            onChange={() =>
              setActivateSelection(StepIdType.SELECT_MEMBERS_TABLE)
            }
            type="radio"
            className={`tw-relative ${
              error ? "tw-border-red-500" : ""
            } tw-mt-0.5 tw-size-4 tw-shrink-0 tw-appearance-none tw-rounded-full tw-border tw-border-gray-300 tw-bg-white before:tw-absolute before:tw-inset-1 before:tw-rounded-full before:tw-bg-white checked:tw-border-blue-600 checked:tw-bg-blue-600 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-blue-600 disabled:tw-border-gray-300 disabled:tw-bg-gray-100 disabled:before:tw-bg-gray-400 forced-colors:tw-appearance-auto forced-colors:before:tw-hidden [&:not(:checked)]:before:tw-hidden`}
          />
          <span className="tw-ml-3 tw-flex tw-flex-col">
            <span className="tw-block tw-text-sm tw-font-medium tw-text-gray-900 group-has-[:checked]:tw-text-blue-900">
              Some members
            </span>
            <span className="tw-block tw-text-sm tw-text-gray-500 group-has-[:checked]:tw-text-blue-700">
              Select specific members you want to activate first (e.g. maybe you
              want to test with a few staff first).
            </span>
          </span>
        </label>
      </fieldset>
    </>
  );
}
